<div class="subject-picker">
  <button class="back-btn" (click)="goBack()">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <h2 class="picker-title">{{'game-mode.quiz.pick-subject' | translate}}</h2>
  <app-daily-bonus></app-daily-bonus>

  <div class="subjects-grid">
    <div
      *ngFor="let subj of subjects"
      class="subject-card"
      [class.bonus]="isBonus(subj.key)"
      [style.--subject-color]="subj.color"
      (click)="selectSubject(subj.key)">
      <span class="subject-icon" [innerHTML]="subj.icon"></span>
      <span class="subject-name">{{'game-mode.subjects.' + subj.key | translate}}</span>
      <span class="bonus-tag" *ngIf="isBonus(subj.key)">{{ 1.5 | arabicNumber:currLang }}x</span>
    </div>
  </div>
</div>
